import React from 'react';
import { Navigate, Outlet, useOutletContext } from 'react-router-dom';
import { useInscriptionState } from '../../../hooks/use-inscription-state.hook';

export const RequireStep1 = () => {
  const ctx = useOutletContext();
  const inscription = useInscriptionState();

  if (!inscription.admin1) return <Navigate to="/inscription/etape-1" replace />;

  return <Outlet context={ctx} />;
};

